var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPopularInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17C9.5 17 1 11.9091 1 5.72728C1 4.63445 1.35402 3.57537 2.00183 2.73024C2.64964 1.88511 3.55121 1.30613 4.55317 1.09181C5.55512 0.877486 6.59556 1.04106 7.49745 1.55471C8.39935 2.06835 9.107 2.90033 9.5 3.9091C9.893 2.90033 10.6006 2.06835 11.5025 1.55471C12.4044 1.04106 13.4449 0.877486 14.4468 1.09181C15.4488 1.30613 16.3504 1.88511 16.9982 2.73024C17.646 3.57537 18 4.63445 18 5.72728C18 11.9091 9.5 17 9.5 17Z",
    stroke: "#737A83",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopularInactive);
export default __webpack_public_path__ + "static/media/popular-inactive.4cb206f96219ae11f69a96784ceca43e.svg";
export { ForwardRef as ReactComponent };